import { Banner } from '@sunwebgroup/uds-ui/banner'
import { space } from '@sunwebgroup/ui-components'
import { IconCell, ListItem, Typography } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import { styled } from 'styled-components'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { shouldShowGoodToKnowAfterAccommodationDescription } from '@/scopes/products/domain/policies/brand'
import { CollectionBanner } from './Collection'
import { MostBookedByLabel } from './MostBookedByLabel'
import { ReadMore } from './ReadMore'

const MostBookedByLabelWrapper = styled.div`
  margin-bottom: ${space('primitives_space_8')};
`

const UspsWrapper = styled(ListItem)`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};
`

const Usp = styled.li`
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_6')};
`

const Wrapper = styled.div`
  gap: ${space('primitives_space_16')};
  display: flex;
  flex-direction: column;
`

function GoodToKnowSection(attentionText: string) {
  const intl = useIntl()

  return (
    <Banner color="informative" hasIcon={false} size="M">
      <Banner.TextsWrapper>
        <Banner.Text>{intl.formatMessage({ id: 'accommodation_page_good_to_know_header_after_accommodation_description' })}</Banner.Text>
        <Banner.SupportingText innerHTML={attentionText} />
      </Banner.TextsWrapper>
    </Banner>
  )
}

export default function Description() {
  const usps = useCMSPageField('PDP.usps')
  const descriptionText = useCMSPageField('PDP.description')
  const attentionText = useCMSPageField('PDP.attention')
  const showGoodToKnowSection = shouldShowGoodToKnowAfterAccommodationDescription(useConfiguration('brandName'))

  if (isEmpty(usps) && !descriptionText) {
    return null
  }

  return (
    <Wrapper>
      <div>
        <MostBookedByLabelWrapper>
          <MostBookedByLabel />
        </MostBookedByLabelWrapper>
        <UspsWrapper variant="transparent" as="ul">
          {!isEmpty(usps) && usps.map(item => (
            <Usp key={item}>
              <IconCell glyph="CheckMarkSmall" verticalAlignment="top" size="sm" />
              <Typography variant="body-m-regular-tight">{item}</Typography>
            </Usp>
          ))}
        </UspsWrapper>
        {descriptionText && (
          <ReadMore content={descriptionText} />
        )}
      </div>

      {showGoodToKnowSection && attentionText
      && (
        GoodToKnowSection(attentionText)
      )}
      <CollectionBanner />
    </Wrapper>
  )
}
